module.exports = __webpack_public_path__ + "static/Affiches-BRIDGE-72ppp-7-380-a54a3ca9b0c41b004fb8bf235d0d3315.png";